import { render, staticRenderFns } from "./u-btn-icon-outlined-circle.vue?vue&type=template&id=109c32ba&scoped=true&"
import script from "./u-btn-icon-outlined-circle.vue?vue&type=script&lang=js&"
export * from "./u-btn-icon-outlined-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109c32ba",
  null
  
)

export default component.exports